/* global lazyload */
'use strict'
const modal = {
	el: {
		btnsTriggerModal: document.querySelectorAll('.js-open-modal'),
		modals: document.querySelectorAll('.js-modal'),
		btnsCloseModal: document.querySelectorAll('.js-close-modal'),
		body: document.body
	},

	fxRenderVideo(event, btn, modal) {
		const videoSrc = btn.dataset.videoSrc,
			modalVideoContainer = modal.querySelector('.video__iframe-container')

		const videoIframe = document.createElement('div')

		videoIframe.classList.add('video__iframe', 'js-lazyframe', 'lazyframe')
		videoIframe.setAttribute('data-vendor', 'youtube')
		videoIframe.setAttribute('data-src', videoSrc)

		modalVideoContainer.append(videoIframe)

		lazyload.fxLazyFrame(videoIframe)
	},

	fxOpenModal(event, element) {
		const modalType = element.dataset.modal ? element.dataset.modal : 'gpf',
			modalContainer = document.querySelector(`.js-modal[data-modal='${modalType}']`)

		event.preventDefault()

		//alert & detail modals
		if(modalType === modalContainer.dataset.modal) {
			const modalContainers = modalContainer.querySelectorAll('.modal__content')

			//show alert/detail container
			for (const container of modalContainers) {
				container.dataset.container === element.dataset.modalContainer ? container.style.display = 'block' : 'none'

				if(container.dataset.container === 'detail') {
					const modalTitle = container.querySelector('.modal__title'),
						modalText = container.querySelector('.modal__text'),
						modalDate = container.querySelector('.modal__date span')
					
					modalTitle.textContent = element.textContent
					modalText.textContent = element.dataset.description !== 'null' ? element.dataset.description : ''
					modalDate.textContent = element.dataset.date
				}
			}

			if(modalType === 'tooltip') {
				const modalTooltipContent = modalContainer.querySelector('.modal__tooltip-content')
				modalTooltipContent.innerHTML = element.dataset.modalContent
			}

			if(modalType === 'video') {
				this.fxRenderVideo(event, element, modalContainer)
			}
			modalContainer.classList.add('open')
		}

		if(modalType === 'switch') {
			const seconds = document.querySelector('.js-countdown')?.dataset.seconds
			countdown.fxCounter(seconds)
		}

		//gpf modal
		if(modalType === 'gpf') {
			const tabs = modalContainer.querySelectorAll('.tab-content'),
				formContainer = modalContainer.querySelectorAll('.jq_tab-content'),
				forms = modalContainer.querySelectorAll('form')
	
			for (const form of forms) {
				form.reset()
			}
	
			tabs.forEach(el => {
				el.dataset.operation === event.currentTarget.dataset.tab ? el.classList.add('selected') : el.classList.remove('selected')
			})
	
			formContainer.forEach(el => {
				el.dataset.container === event.currentTarget.dataset.tab ? el.classList.remove('d-none') : el.classList.add('d-none')
			})
		}

		this.el.body.classList.add('no-scroll-hidden')
	},

	fxCloseModal(element) {
		const modal = element.closest('.modal')
		
		modal.classList.remove('open')
		modal.classList?.remove('open-static')

		const modalContainers = modal.querySelectorAll('.modal__content')

		if(modalContainers.length !== 0) {
			modalContainers.forEach(el => el.style.display = 'none')
		}

		if(modal.dataset.modal === 'video') {
			const iframe = modal.querySelector('.video__iframe')
			iframe.remove()
		}

		if(cookieHub.fxGetCookieHub() !== undefined) {
			cookieHub.fxRemoveCookieHub()
		}
		
		this.el.body.classList.remove('no-scroll-hidden')
	},

	events () {
		for(const btn of this.el.btnsTriggerModal) {
			btn.addEventListener('click', e => this.fxOpenModal(e, e.currentTarget))
		}

		for(const btn of this.el.btnsCloseModal) {
			btn.addEventListener('click', e => this.fxCloseModal(e.currentTarget))
		}
	},

	init () {
		if(this.el.btnsTriggerModal.length === 0 || !this.el.btnsCloseModal) return
		this.events()
	}
}

modal.init()